module.exports = __webpack_public_path__ + "static/img/(query) none data@3x.1c781c4d.png";